/**
 * Redirect user to the browser warning page if Internet Explorer is detected
 */

var ie = 0;
try {
    ie = Number(navigator.userAgent.match(/(MSIE |Trident.*rv[ :])([0-9]+)/)[2]);
} catch (e) {
}

if (ie !== 0) {
    window.location.href = '/browser-warning';
}


/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('../select2-3.5.2');
require('html5sortable');
require('./select2.sortable');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

let apiToken = document.head.querySelector('meta[name="api-token"]') || null;

if(apiToken){
    window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + apiToken.content;
}
if (locale === 'en') {
    require('./front-en');
} else if (locale === 'nl') {
    require('./front-nl');
}
import Api from './api';
import ApiAxios from './ApiAxios';

window.api = new Api(new ApiAxios(axios));

window.Vue = require('vue');
window.Vue.mixin(require('./components/VueMixin.js'));

try {
    if (process.env.MIX_FRONT_APP_ENV === 'production') {
        if (process.env.MIX_SENTRY_JAVASCRIPT_DSN) {
            Sentry.init({
                dsn: process.env.MIX_SENTRY_JAVASCRIPT_DSN,
                integrations: [new Sentry.Integrations.Vue({ Vue })]
            })
        }
    }
} catch (e) {
    console.error("Error integrating sentry: ", e.toString());
}

Vue.component('error-ele', require('./components/common/Error.vue'));
Vue.component('alert-ele', require('./components/common/Alert.vue'));
Vue.component('switch-button', require('./components/form/SwitchButton.vue'));
Vue.component('radio-group', require('./components/form/RadioGroup.vue'));
Vue.component('button-loader', require('./components/common/ButtonLoader.vue'));
Vue.component('register', require('./components/auth/register/Form.vue'));
Vue.component('profile', require('./components/user/Profile'));
Vue.component('tool-subscription-form', require('./components/subscription/ToolSubscriptionForm'));
Vue.component('capripedia-subscription-form', require('./components/subscription/CapripediaSubscriptionForm'));
Vue.component('decision-node', require('./components/decision-tree/DecisionNode.vue'));
Vue.component('decision-tree-edit', require('./components/decision-tree/Edit.vue'));
Vue.component('payment-under-process', require('./components/subscription/PaymentUnderProcessScreen.vue'));
Vue.component('confirmation-modal', require('./components/common/ConfirmationModal.vue'));
Vue.component('package-subscription-payment-screen', require('./components/subscription/PackageSubscriptionPaymentScreen'));



// WEBPACK FOOTER //
// ./resources/js/app.js